import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=077e439a"
import script from "./NoticeBar.vue?vue&type=script&lang=js"
export * from "./NoticeBar.vue?vue&type=script&lang=js"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&id=077e439a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports